import React, { useContext, useEffect, useState } from "react";
import ProductCardMobile from "./ProductCardMobile";
import { httpReauest } from "../../../utils/httpRequest";
import { Link } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import Loading from "../Loading";
import SearchIcon from "../../../icons/SearchIcon";
import { useFormik } from "formik";
import { FilterContext } from "../../../context/FilterContext";
import { CDN_BASE_URL } from "../../../config";

export function toEnglishDigits(num) {
  const id = {
    "۰": "0",
    "۱": "1",
    "۲": "2",
    "۳": "3",
    "۴": "4",
    "۵": "5",
    "۶": "6",
    "۷": "7",
    "۸": "8",
    "۹": "9",
  };
  return num
    ? num.toString().replace(/[^0-9.]/g, function (w) {
        return id[w] || w;
      })
    : null;
}

const ProductsMobile = ({ fit }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState();
  const [hasmore, sethasmore] = useState(true);
  const [category, setcategory] = useState([]);
  const [loadmore, setloadmore] = useState(false);

  const { sort, setsort } = useContext(FilterContext);
  const formik = useFormik({
    initialValues: {
      category: "",
      name: "",
      brand: "",
      search_key: "",
    },
  });

  useEffect(() => {
    if (!fit) {
      getData();
    }
  }, []);

  useEffect(() => {
    newfetchData();
  }, [formik.values.brand, formik.values.name, fit, sort]);

  async function getData() {
    if (!loading) {
      setLoading(true);
      await httpReauest("GET", "/category", {}, {}).then(({ data }) => {
        setcategory(data?.data);
      });
      setLoading(false);
    }
  }

  async function newfetchData() {
    if (!loading) {
      setLoading(true);
      const page = 1;
      await httpReauest(
        "GET",
        "/vehicle?page=" +
          page +
          "&category=" +
          formik.values.category +
          "&search_key=" +
          formik.values.search_key +
          "&sort=" +
          sort +
          `${fit ? "&fit=" + fit : ""}`,
        {},
        {}
      ).then(({ data }) => {
        setProducts(data.data);
        console.log("first");
        setLoading(false);

        if (data?.data?.length == 16) {
          sethasmore(true);
        } else {
          sethasmore(false);
        }
      });
    }
  }

  useEffect(() => {
    newfetchData();
  }, [formik.values.category]);

  async function fetchData() {
    if (!loading) {
      const page = products.length / 16 + 1;
      await httpReauest(
        "GET",
        "/vehicle?page=" +
          page +
          "&fit=" +
          fit +
          "&category=" +
          formik.values.category +
          "&search_key=" +
          formik.values.search_key +
          "&sort=" +
          sort,
        {},
        {}
      ).then(({ data }) => {
        setProducts((cur) => [...cur, ...data.data]);
        if (data?.data?.length < 16) {
          sethasmore(false);
        }
      });
    }
  }

  async function handleChange(e) {
    const value = e.target.value;

    formik.setFieldValue("search_key", toEnglishDigits(value));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    await httpReauest(
      "GET",
      "/vehicle?page=" +
        "1" +
        "&fit=" +
        fit +
        "&category=" +
        formik.values.category +
        "&search_key=" +
        formik.values.search_key +
        "&sort=" +
        sort,
      {},
      {}
    ).then(({ data }) => {
      setProducts(data.data);
      if (data?.data?.length < 16) {
        sethasmore(false);
      }
    });
  }
  return (
    <>
      <div className="mt-2   sticky top-[78px] bg-white py-1 z-20">
        <div className="flex gap-2">
          <form onSubmit={handleSubmit} className="w-full relative">
            <input
              onChange={handleChange}
              className="w-full h-[58px] border outline-none placeholder:text-[#5C5F5F] placeholder:text-[16px] text-[16px] rounded-[10px] border-[#EAEAEA] ps-12 "
              placeholder="جستجو در همه آگهی ها"
              id="search_key"
              name="search_key"
            />
            <span className="absolute translate-y-[-50%] top-[50%] right-4">
              <SearchIcon />
            </span>
          </form>
          <Link
            to={"/category"}
            className="px-4 border rounded-[10px] border-[#EAEAEA]"
          >
            <img
              src="/Filter2.png"
              alt="filter"
              className=" h-full object-contain scale-125"
            />
          </Link>
        </div>

        <div className="w-full flex gap-2 py-2 mb-3 overflow-x-scroll border-b border-dashed border-[#8E9192]">
          {category?.map((cat) => (
            <span
              onClick={() => {
                if (cat._id === formik.values.category) {
                  formik.setFieldValue("category", "");
                } else {
                  formik.setFieldValue("category", cat._id);
                }
              }}
              className={`${
                formik.values.category === cat._id ? "bg-black text-white" : ""
              } border-brand-2 px-3 py-2 whitespace-nowrap font-bold flex flex-col justify-between items-center`}
            >
              <img
                src={CDN_BASE_URL + cat.img}
                alt={cat.name}
                className="w-12 h-10 object-contain"
              />
              {cat.name}
            </span>
          ))}
        </div>
      </div>
      <span className="relative ms-auto pt-2">
        <select
          id="lazing"
          name="lazing"
          onChange={(e) => setsort(e.target.value)}
          className={` form-brand h-[35px] w-full`}
        >
          <option value={"-createdAt"}> جدید ترین</option>
          <option value={"createdAt"}> قدیمی ترین</option>
          <option value={"price"}> ارزان ترین</option>
          <option value={"-price"}> گران ترین</option>
          <option value={"-year"}> سال ساخت از بیشترین</option>
          <option value={"year"}> سال ساخت از کمترین</option>
        </select>
        <p className="on-border">مرتب سازی</p>
      </span>
      {loading ? (
        <Loading />
      ) : (
        <InfiniteScroll
          dataLength={products?.length ? products?.length : 16} //This is important field to render the next data
          next={fetchData}
          hasMore={hasmore && loadmore}
          loader={
            <div className="w-full flex justify-center">
              <Loading />
            </div>
          }
          style={{ overflow: "visible", minHeight: "80vh" }}
        >
          {products?.map((e, i) => (
            <span key={i}>
              <ProductCardMobile data={e} />
            </span>
          ))}
          {products.length
            ? !loadmore && (
                <div className="col-span-full flex justify-center mt-4">
                  <button
                    onClick={() => setloadmore(true)}
                    className="btn-brand"
                  >
                    بارگزاری بیشتر
                  </button>
                </div>
              )
            : null}
        </InfiniteScroll>
      )}
    </>
  );
};

export default ProductsMobile;
